import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check_light",
  "use": "icon-check_light-usage",
  "viewBox": "0 0 35 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 35 24\" id=\"icon-check_light\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-7-12h48v48H-7z\" /><path fill=\"#FFF\" d=\"M13 18.344 31.384-.042l2.83 2.828L13 24 .272 11.272 3.1 8.444z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol